module.exports = __webpack_public_path__ + "img/超低.967813c1.webp";